/***************** TAB SCRIPTS *******************/
const toggles = document.querySelectorAll('[data-toggle-target]');
const tabs = document.querySelectorAll('[data-tab-target]');
const modals = document.querySelectorAll('[data-modal-target]');

toggles.forEach((toggle) => {
  toggle.addEventListener('click', (event) => {
    console.log(event);
    slideToggle(toggle,event);
 
    const toggleTarget = toggle.dataset.toggleTarget;
    if (toggle.hasAttribute('data-toggle-reset')) {
      const toggles = document.querySelectorAll('[data-toggle-target]');
      const targets = document.querySelectorAll('[data-toggle-content]');

      toggles.forEach((toggle) => {
        if (!toggle) {
          toggle.classList.remove('active');
        }
      });
      targets.forEach((toggle) => {
        if (toggle.dataset.toggleContent !== toggleTarget) {
          toggle.classList.remove('active');

          setTimeout(function () {
            toggle.style.height = '0px';
          }, 0);
        }
      });
    } 

    if (toggle.hasAttribute('data-close-outside')) {
      const parent = toggle.closest('[data-toggle-content]');
      toggleTargetName = parent.dataset.toggleContent;
      parent.classList.remove('active');
      document
        .querySelector(`[data-toggle-target="${toggleTargetName}"]`)
        .classList.remove('active');
    }
  });
});

tabs.forEach((tab) => {
  tab.addEventListener('click', (event) => {
    tabToggle(tab, event);
  });
});

modals.forEach((modal) => {
  modal.addEventListener('click', (event) => {
    modalPop(modal);
  });
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    const closeItems = document.querySelectorAll('[data-close-outside]');
    closeItems.forEach((item) => {
      parent = item.closest('[data-toggle-content]');
      toggleTargetName = parent.dataset.toggleContent;
      parent.classList.remove('active');
      document
        .querySelector(`[data-toggle-target="${toggleTargetName}"]`)
        .classList.remove('active');
    });

    //console.log('Escape key pressed');
  }
});
/***************** SLIDE TOGGLES *******************/
function slideToggle(toggle, event) {
  event.preventDefault();
  const toggles = document.querySelectorAll('[data-toggle-target]');
  const targets = document.querySelectorAll('[data-toggle-content]');

  const target = toggle.dataset.toggleTarget;

  const toggleContainer = document.querySelectorAll(
    `[data-toggle-content="${target}"]`
  );

  // FOR RESETTING ALL ITEMS
 
  if (toggle.hasAttribute('data-reset')) {
    toggles.forEach((toggle) => {
      if (
        (toggle.dataset.toggleTarget == target) &
        toggle.classList.contains('active')
      ) {
        toggle.classList.remove('active');
      } else {
        toggle.classList.add('active');
      }
      if (toggle.dataset.toggleTarget != target) {
        toggle.classList.remove('active');
      }
    });
    targets.forEach((toggle) => {
      if (toggle.dataset.toggleContent != target) {
        toggle.classList.remove('active');
      }
    });
  }

  toggleContainer.forEach((group) => {
    if (!group.classList.contains('active')) {
      toggles.forEach((toggle) => {
        if (toggle.dataset.toggleTarget == target) {
          toggle.classList.add('active');
        }
      });

      group.classList.add('active');
      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      group.style.height = '0px';

      setTimeout(function () {
        group.style.height = height;
      }, 0);

      group.addEventListener(
        'transitionend',
        function () {
          group.style.height = 'auto';
        },
        {
          once: true,
        }
      );
    } else {
      toggles.forEach((toggle) => {
        // console.log(toggle.dataset.toggleTarget, 'DATA TARGET');
        if (toggle.dataset.toggleTarget == target) {
          toggle.classList.remove('active');
        }
      });

      group.style.height = 'auto';
      const height = group.offsetHeight + 'px';
      // console.log(height, 'height');
      group.style.height = height;

      setTimeout(function () {
        group.style.height = height;
        group.classList.remove('active');
        group.style.height = '0px';
        //console.log('remove active', group);
      }, 0);
      group.addEventListener(
        'transitionend',
        function () {
          //console.log('close toggle transition end');
          group.style.height = '0px';
        },
        {
          once: true,
        }
      );
    }
  });
}
/*************** TAB TOGGLES ***********/
function tabToggle(tab, event) {
  ;
   event.preventDefault();
   const target = tab.dataset.tabTarget;
   const tabGroup = tab.dataset.tabGroup;
   const tabGroups = document.querySelectorAll(`[data-tab-group="${tabGroup}"]`);
   tabGroups.forEach((group) => {
     group.classList.remove('active');
   });
   event.target.classList.add('active');
   document
     .querySelectorAll(
       `[data-tab-content="${target}"][data-tab-group="${tabGroup}"]`
     )
     .forEach((group) => {
       group.classList.add('active');
     });
 }

// MODAL TOGGLING
function modalPop(modal) {
  const target = modal.dataset.modalTarget;
  const modalContent = document.querySelector(
    `[data-modal-content="${target}"]`
  );
  const closeModal = modalContent.querySelector('[data-close]');
  const closeModalThanks = modalContent.querySelector('[data-close-thanks]');
  const modalSlider = modalContent.querySelector('.bd-slider');
  modalContent.classList.add('active');
  document.querySelector('body').classList.add('overflow-hidden');
  closeModal.onclick = function () {
    //  console.log('close modal');
    modalContent.classList.remove('active');
    document.querySelector('body').classList.remove('overflow-hidden');
  };
  closeModalThanks.onclick = function () {
    //  console.log('close modal');
    modalContent.classList.remove('active');
    document.querySelector('body').classList.remove('overflow-hidden');
  };
  window.onclick = function (event) {
    // console.log(event);
    if (event.target == modalContent) {
      // console.log('close modal');

      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  };
  window.addEventListener('keyup', function (e) {
    if (e.code === 'Escape') {
      modalContent.classList.remove('active');
      document.querySelector('body').classList.remove('overflow-hidden');
    }
  }); 
  if (modalSlider) {
    const slider = new slick(modalSlider);
    // console.log('resize slider');
    slider.resize();
  }
} 
